import { Component, OnInit, Input } from "@angular/core";
import { CommonApiService } from "src/app/services/common-api.service";
import { MqttService } from "src/app/services/mqtt.service";
import { first } from "rxjs/operators";
import { environment } from "src/environments/environment";
import * as moment from 'moment';

declare var $: any;
@Component({
  selector: "app-main-page",
  templateUrl: "./main-page.component.html",
  styleUrls: ["./main-page.component.scss"],
})
export class MainPageComponent implements OnInit {
  @Input() meterId: Number;
  estimatedConsumption: any;
  mqttService: any;
  liveActivePower: String;
  loader: boolean = false;
  currentDate: any;
  mqttTime: any;
  lastTime: any;
  constructor(private commonApi: CommonApiService) { }

  ngOnInit(): void {
    this.loader = true;
    // if(this.meterId){
    //   this.ngOnChanges()
    // }
  }

  ngOnChanges() {
    console.log("DAta change ==>", this.meterId);
    this.lastTime = "trying to connect..."
    this.liveActivePower = null;
    this.startLiveData();
    this.renderEstimatedConsumption();
  }

  startLiveData() {
    // close old connection if any
    // start new mqtt subscription
    if (this.mqttService) {
      this.mqttService.close();
      this.mqttService = null;
    }
    this.mqttService = new MqttService(environment.mqtt_host, [this.meterId]);
    this.mqttService.listen().subscribe((data) => {
      this.liveActivePower = data.a.toFixed(1);

      this.mqttTime = moment(data.t);
      console.log(this.mqttTime, "MQTT TIME");

      // this.getLastUpdateTime();

      this.lastTime = moment(data.t * 1000).from(moment())
      console.log(this.lastTime);
      localStorage.setItem('lastUpdated', this.lastTime)




    });
  }
  ngOnDestroy() {
    if (this.mqttService) this.mqttService.close();
  }

  renderEstimatedConsumption() {
    // fetch data from api
    this.commonApi
      .getEstimatedConsumption()
      .pipe(first())
      .subscribe((res) => {
        this.loader = false;
        this.estimatedConsumption = res;
      });
  }



}
